import { render, staticRenderFns } from "./CompanyCustomization.vue?vue&type=template&id=66239524&scoped=true"
import script from "./CompanyCustomization.vue?vue&type=script&lang=js"
export * from "./CompanyCustomization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66239524",
  null
  
)

export default component.exports